module.exports = __webpack_public_path__ + "static/l7-mobile-efaed3f8deb6c7da45791885315f0cfb.png";